/** Default slider tick values for AMC SIP calculator (min and max only). */
export const DEFAULT_INVESTMENT_SLIDER_MARKERS = [100, 100_000_000] as const;

export const DEFAULT_TENURE_SLIDER_MARKERS = [1, 40] as const;

export const DEFAULT_INTEREST_RATE_SLIDER_MARKERS = [1, 30] as const;
